import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Redo2: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm15 14 5-5-5-5' }],
    ['path', { d: 'M20 9H9.5A5.5 5.5 0 0 0 4 14.5v0A5.5 5.5 0 0 0 9.5 20H13' }],
  ],
];

export default Redo2;
